import { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import {
    Stack,
    MenuItem,
} from '@mui/material';

import { useTranslation } from 'react-i18next';

function DurationPicker({ id, value, onChange, type }) {
    const { t } = useTranslation()
    const mins = Math.trunc(Math.abs(value) / 1000 / 60)
    const [hours, setHours] = useState(Math.trunc(mins / 60));
    const [minutes, setMinutes] = useState(mins % 60);
    const [sign, setSign] = useState(type === 'negative' ? '-' : type === ' positive' ? '+' : value < 0 ? '-' : '+');

    useEffect(() => {
        onChange({
            id: id,
            value: sign === '+' ? hours * 60 * 60 * 1000 + minutes * 60 * 1000 : -(hours * 60 * 60 * 1000 + minutes * 60 * 1000)
        });
    }, [sign, hours, minutes]);

    useEffect(() => {
        setHours(Math.trunc(mins / 60))
        setMinutes(mins % 60)
        setSign(type === 'negative' ? '-' : type === ' positive' ? '+' : value < 0 ? '-' : '+')
    }, [value, mins]) 

    return (
        <Stack direction='row' spacing={1} sx={{ m: 1 }} >
            <TextField
                select
                label=''
                disabled={type === 'negative' || type === 'positive'}
                value={sign}
                onChange={(e) => setSign(e.target.value)}
            >
                {[
                    <MenuItem key={'+'} value={'+'} >+</MenuItem>,
                    <MenuItem key={'-'} value={'-'} >-</MenuItem>
                ]}
            </TextField>
            <TextField
                label={t('stunden', { ns: 'common', defaultValue: 'Stunden' })}
                type="number"
                value={hours}
                InputProps={{ inputProps: { min: 0 } }}
                onChange={(e) => setHours(Number(e.target.value))}
            />
            <TextField
                label={t('minuten', { ns: 'common', defaultValue: 'Minuten' })}
                type="number"
                value={minutes}
                InputProps={{ inputProps: { min: 0 } }}
                onChange={(e) => setMinutes(Number(e.target.value))}
            />
        </Stack>
    );
};

export default DurationPicker
